/**
 * Resolves the ask-gyg iframe URL. An empty result means the feature isn't available.
 */
export function getAskGygUrl(): string {
  return process.env.NEXT_PUBLIC_ASK_GYG_URL_AU || ''
}
